import { createAction } from "@reduxjs/toolkit";
export const CONNECT_SSE = 'CONNECT_SSE';
export const DISCONNECT_SSE = "DISCONNECT_SSE";

export const connectSseAction = createAction(CONNECT_SSE);
export const disconnectSseAction = createAction(DISCONNECT_SSE);